export const openModal = user => ({
  type : '@risa/OPENMODAL',
  user : user
})

export const closeModal = () => ({
  type : '@risa/CLOSEMODAL'
})
